import { defineNuxtRouteMiddleware } from '#app';
// import { useWebsiteStore } from '~/stores/websiteStore';

// interface PageAnimationOptions {
//   excludes: string[];
//   fromName?: string;
//   toName?: string;
// }

export default defineNuxtRouteMiddleware(async (to, from) => {
  // if (import.meta.client) {
  // const websiteStore = useWebsiteStore();
  // const deviceType = useState('deviceType');
  //
  // // Проверка: запускаем логику только если изменилось название маршрута (to.name и from.name различны)
  // if (to.name === from.name) {
  //   return;
  // }
  //
  // const animationOptions: PageAnimationOptions = {
  //   excludes: ['personal'],
  //   fromName: typeof from.name === 'string' ? from.name : undefined,
  //   toName: typeof to.name === 'string' ? to.name : undefined,
  // };
  //
  // const { fromName, toName, excludes } = animationOptions;
  //
  // // Ищем совпадения с исключениями
  // const hasOverlap = excludes.some((exclude) => fromName?.includes(exclude) && toName?.includes(exclude));
  //
  // // Только если маршруты подходят под условия
  // if (!hasOverlap) {
  //   websiteStore.pageHiddenPoint = true;
  //   websiteStore.blockTabBar = true;
  // }
  //
  // if (deviceType.value !== 'desktop') {
  //   // await new Promise(resolve => setTimeout(resolve, 300));
  // }
  // }
});
